import { Settings, Undo2 } from 'lucide-react';
import React, { useContext, useState } from 'react';
import { AutomationEditorContext } from '../AutomationEditorContext';
import styles from './SettingsControls.module.css';
import { SettingsDialog } from './SettingsDialog';

export const SettingsControl: React.FC<{ disabled?: boolean }> = ({ disabled = false }) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const { editor } = useContext(AutomationEditorContext)!;
  const { state, undoSettings } = editor;
  const isDirty = state.dirtySteps.settings;

  return (
    <>
      {isDirty && (
        <button
          type="button"
          onClick={undoSettings}
          className={styles.undoButton}
          aria-label="Undo settings changes"
          title="Undo settings changes"
          disabled={disabled}>
          <Undo2 />
        </button>
      )}
      <button
        type="button"
        onClick={() => setDialogOpen(true)}
        className={styles.settingsButton}
        disabled={disabled}
        title={disabled ? 'Not available while sync is in progress' : undefined}
        aria-label="Automation settings">
        <Settings className={styles.settingsIcon} />
      </button>
      <SettingsDialog open={dialogOpen} onClose={() => setDialogOpen(false)} />
    </>
  );
};
